import Logger from "@/utils/logger.js";

export function urlChatID() {
    let curLocation = new URL(document.location.href)
    let matches = curLocation.pathname.match('chatbot/([a-z0-9]{24})')
    if (!matches) {
        return ''
    }

    if (matches.length < 2 || !matches[1]) {
        return ''
    }
    return  matches[1]
}

export function urlConversationID() {
    let curLocation = new URL(document.location.href)
    let matches = curLocation.pathname.match('chatbot/([a-z0-9]{24})/conversations/([a-z0-9]{24})')
    if (!matches) {
        return null
    }

    if (matches.length < 3 || !matches[2]) {
        return ''
    }
    return  matches[2]
}

export function isValidUrl(string) {
    try {
        const newUrl = new URL(string);
        return newUrl.protocol === 'http:' || newUrl.protocol === 'https:';
    } catch (err) {
        return false;
    }
}

export function getSecondLevelDomain(url) {
    try {
        const urlObj = new URL(url.startsWith('http') ? url : 'http://' + url);
        const hostname = urlObj.hostname;

        const parts = hostname.split('.');

        if (parts.length < 2) return hostname;

        return parts.slice(-2).join('.');
    } catch (error) {
        const domain = url.replace(/^https?:\/\//, '').split('/')[0];
        const parts = domain.split('.');
        return parts.length >= 2 ? parts.slice(-2).join('.') : domain;
    }
}